import axios from "axios";
import camelize from "camelize-ts";
import { User } from "./types";
import moment from "moment";
const fetchLastStatus = async (username: any, tenant_id: any, device_id: any) => {
    const { data } = await axios.get(`${process.env.REACT_APP_ROUTING_SERVICE}/presence/${username}/${tenant_id}/${device_id}`);
    return data;
};
export const sendLogoutStatus = async (user: any) => {
    const url = `${String(process.env.REACT_APP_ROUTING_SERVICE)}/presence`;
    const payload = {
        tenant_id: user?.tenantId,
        device_id: user?.deviceId,
        status: "offline",
        device_info: "logout",
        presence_time: moment().toDate(),
        username: user?.username
    }
    await axios.post(url,payload);
}
export const getSession = async () => {
    const url = `${process.env.REACT_APP_AUTH_SERVICE}/session`;
    axios.defaults.headers.common['Cache-Control'] = 'no-cache'
    const { data: resData } = await axios.get(url);
    const { data } = resData;
    const {
        device_id: deviceId,
        fullname,
        role_name: roleName,
        role_description: roleDescription,
        username,
        id: userId,
        profile_picture: profilePicture,
        tenant_id: tenantId,
        password_expiry_date: passwordExpiryDate,
        displayname,
        gender,
        dob,
        tenant_name: tenantName,
        cm_role_id: cmRoleId,
        cm_role_name: cmRoleName,
        cm_role_description: cmRoleDescription,
        institution_id: institutionId,
        institution_name: institutionName,
        email,
        level
    } = data.user;

    const lastStatus = await fetchLastStatus(data?.user?.username, data?.user?.tenant_id, data?.user?.device_id);

    const userResult: User = {
        deviceId,
        fullname,
        roleName,
        roleDescription,
        username,
        userId,
        profilePicture,
        tenantId,
        passwordExpiryDate,
        displayname,
        gender,
        dob,
        tenantName,
        cmRoleId,
        cmRoleName,
        cmRoleDescription,
        institutionId,
        institutionName,
        email,
        status: lastStatus?.data?.status,
        deviceInfo: lastStatus?.data?.reason,
        level
    };

    const result = {
        user: userResult,
        navigations: data.navigations,
        routes: data.routes
    }
    return camelize(result);
}

export const getUser = async () => {
    const { data: resData } = await axios.get(`${process.env.REACT_APP_AUTH_SERVICE}`);

    const { data } = resData;

    return camelize(data);

};

